
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { CheckInTable } from "@/components/check-in/check-in-table"
import { useUser } from "@/contexts/user-context"
import { useGym } from "@/contexts/gym-context"
import { useView } from "@/contexts/view-context"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

export default function CheckInPage() {
  const { t } = useTranslation()
  const [refreshKey, setRefreshKey] = useState(0)
  const { user, isLoading: isUserLoading } = useUser()
  const { gyms, selectedGym, selectGym, isLoading: isGymsLoading } = useGym()
  const { viewMode } = useView()

  // Filter gyms based on user's assigned gyms
  const userGyms = user && user.gym ? gyms.filter((gym) => user.gym.includes(gym._id)) : gyms

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between mb-4">
      <h1 className="text-3xl font-bold">{t("checkIn.title")}</h1>
      {(viewMode === "admin" || viewMode === "reception") && userGyms.length > 1 && (
        <Select value={selectedGym} onValueChange={selectGym}>
          <SelectTrigger className="w-[180px] md:w-[220px]">
            <SelectValue placeholder={t("dashboard.selectGym")}>
              {userGyms.find((gym) => gym._id === selectedGym)?.name || t("dashboard.selectGym")}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {/* {viewMode === "admin" && userGyms.length > 1 && (
                  <SelectItem value="all">{t("dashboard.allGyms")}</SelectItem>
                )} */}
            {userGyms.map((gym) => (
              <SelectItem key={gym._id} value={gym._id}>
                {gym.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      </div>
      <CheckInTable key={refreshKey} />
    </div>
  )
}
